// To be used every time multiple classes are needed. Can handle boolean expressions
export const combine = (...classes) => {
  return classes.filter(Boolean).join(" ");
};
